import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { z } from 'zod';

import { ConfigStore } from '@sureinc/atlas-common/config';
import { ThemeProvider } from '@emotion/react';
import { StyledEngineProvider } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';

import { setEnvironment } from '@/utils/env.utils';
import Logger from '@/lib/logger';
import { initLogRocket, isLogRocketEnabled } from '@/utils/logrocket.utils';
import { env } from '@/config/env.config';
import { handleVitePreloadError } from '@/utils/buildRecovery';
import { App } from './App';

import theme from './theme';
import './App.css';

z.config({
  customError: (issue) => {
    if (issue.code === 'invalid_type') {
      return 'common:inputs.errors.required';
    }
    return undefined;
  },
});

setEnvironment();
initLogRocket();

if (env.VITE_ENVIRONMENT === 'production') {
  window.addEventListener('vite:preloadError', handleVitePreloadError);
}

if (isLogRocketEnabled && env.VITE_LOGROCKET_LOG_TEST === 'true') {
  Logger.trace('this is trace log');
  Logger.debug('this is debug log');
  Logger.info('this is info log');
  Logger.warn('this is warn log');
  Logger.error('this is error log');
  Logger.log('this is normal (debug) log');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <StyledEngineProvider enableCssLayer>
      <ThemeProvider theme={theme}>
        <GlobalStyles styles="@layer theme, base, mui, components, utilities;" />
        <App />
      </ThemeProvider>
    </StyledEngineProvider>
  </StrictMode>
);

if (env.VITE_ENVIRONMENT !== 'production') {
  const bold =
    'font-weight: bold; background-color: rgb(148 138 171); color: #000';
  const normal = 'font-weight: normal';
  // eslint-disable-next-line no-console
  console.log(
    `Bexa Atlas %c${env.VITE_ENVIRONMENT}%c version: %c${__APP_VERSION__}%c. \n\nAtlas common library version: %c${ConfigStore.config.__meta.version}%c.`,
    bold,
    normal,
    bold,
    normal,
    bold,
    normal
  );
}
